<template lang="pug">
  .event-grid
    Event(v-for="event in data"
      :key="event.id"
      :event="event"
    )
</template>

<script>
import Event from '@/components/EventGrid/Event'

export default {
  name: 'DefaultEventGrid',
  components: {Event},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>
